export default "__VITE_ASSET__DNel_Yym__"